import { useMutation as e } from "@maat/store-hooks";
import { adminNotificationsApi as t } from "@maat/api-notifications";
//#region src/notifications/admin/usePreviewAdminNotificationTemplateMutation.ts
var n = () => e({ mutationFn: (e) => t.previewTemplate(e.id, e.data) });
//#endregion
export { n as usePreviewAdminNotificationTemplateMutation };
